<template>
  <div>
    <v-card class="grid_line_second" elevation="0">
      <v-card elevation="6" class="mr-md-2 mr-lg-2 mr-xl-2">
        <div class="pa-3">
          <div class="grid_customer_list">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_customer_list" :src="img_customer_list"/>
            </div>
            <div class="pt-2 pl-2" style="font-size: 26px">
              <div class="grid_flex">
                <div><b>จำนวนลูกค้าทั้งหมด</b></div>
                <div><b>{{ format_number(all) }} คน</b></div>
              </div>
            </div>
          </div>
        </div>
        <div class="ma-2">
          <div class="grid_product_half">
            <div class="ma-2">
              <v-card elevation="3" @click="customer_cash">
                <div class="pa-3">
                  <div class="font_customer"><b>ลูกค้าส่ง (เงินสด)</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_retail_customer" :src="img_retail_customer"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(cash) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="customer_retail">
                <div class="pa-3">
                  <div class="font_customer"><b>ลูกค้าปลีก</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_sale_customer" :src="img_sale_customer"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(ecom) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="customer_cash">
                <div class="pa-3">
                  <div class="font_customer"><b>ลูกค้าส่ง (เครดิต)</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_retail_customer" :src="img_retail_customer"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(credit) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="partner_page">
                <div class="pa-3">
                  <div class="font_customer"><b>พาร์ทเนอร์</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_partner" :src="img_partner"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(partner) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </v-card>
      <v-card elevation="6" class="ml-md-2 ml-lg-2 ml-xl-2">
        <div class="pa-3">
          <div class="grid_customer_list">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_list" :src="img_product_list"/>
            </div>
            <div class="pt-2 pl-2" style="font-size: 26px">
              <div class="grid_flex">
                <div><b>จำนวนสินค้าทั้งหมด</b></div>
                <!-- <div><b>{{ format_number(total_product.productall) }} ชิ้น</b></div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="ma-2">
          <div class="grid_product_three">
            <div class="ma-2">
              <v-card elevation="3" @click="expired_page">
                <div class="pa-3">
                  <div class="font_customer"><b>รายการสินค้าที่ไม่ได้ตั้งราคา</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_expired" :src="img_expired"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(total_product.expired) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="low_stock_page">
                <div class="pa-3">
                  <div class="font_customer"><b>รายการสินค้า Low Stock</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_low_stock" :src="img_low_stock"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(total_product.product_low_stock) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="cn_page">
                <div class="pa-3">
                  <div class="font_customer"><b>จำนวน CN ที่รอรับคืน</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_cn" :src="img_cn"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(total_product.total_refunds) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="low_price_page">
                <div class="pa-3">
                  <div class="font_customer"><b>จำนวนสินค้าราคาต่ำกว่าทุน</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_low_price" :src="img_low_price"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(total_product.total_pricelow) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="high_price_page">
                <div class="pa-3">
                  <div class="font_customer"><b>จำนวนสินค้าทุนขึ้น</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_high_price" :src="img_high_price"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(total_product.total_priceup) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="ma-2">
              <v-card elevation="3" @click="order_stable">
                <div class="pa-3">
                  <div class="font_customer"><b>จำนวนสั่งซื้อที่คงค้าง</b></div>
                  <div class="grid_count mt-2">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_standing" :src="img_product_standing"/>
                    </div>
                    <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(total_product.ordercount) }}</b></div>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </v-card>
    </v-card>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="#86bc3a"
        ></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import {formatNumber} from "@/js/handler";
import img_customer_list from "@/assets/value_refund.png";
import img_retail_customer from "@/assets/consumer_total.png";
import img_sale_customer from "@/assets/shopping-cart_sale.png";
import img_partner from "@/assets/cooperation.png";
import img_expired from "@/assets/price.png";
import img_low_stock from "@/assets/low_stock_report.png";
import img_cn from "@/assets/refund_report.png";
import img_low_price from "@/assets/loss.png";
import img_high_price from "@/assets/profits_1.png";
import img_product_standing from "@/assets/delivery-time_product.png";
import img_product_list from "@/assets/box_refund.png";
import {HTTP} from "@/axios";

export default {
  name: "Customer_product_all",
  data() {
    return {
      overlay: false,
      img_customer_list: img_customer_list,
      img_product_list: img_product_list,
      img_retail_customer: img_retail_customer,
      img_sale_customer: img_sale_customer,
      img_partner: img_partner,
      img_expired: img_expired,
      img_low_stock: img_low_stock,
      img_cn: img_cn,
      img_low_price: img_low_price,
      img_high_price: img_high_price,
      img_product_standing: img_product_standing,
      all: 0,
      cash: 0,
      credit: 0,
      partner: 0,
      ecom: 0,
      total_product: 0,
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    get_data() {
      this.overlay = true
      HTTP.post('/dashboards/customers')
          .then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              this.all = res.data.object.total_customer.all
              this.cash = res.data.object.total_customer.cash
              this.credit = res.data.object.total_customer.credit
              this.partner = res.data.object.total_customer.partner
              this.ecom = res.data.object.total_customer.ecom
              this.total_product = res.data.object.total_product
            }
          })
    },
    customer_cash() {
      this.$router.push('/customer')
    },
    customer_retail() {
      this.$router.push('/retailer')
    },
    partner_page() {
      this.$router.push('/partner')
    },
    expired_page() {
      this.$router.push('/stock/manage_product/productnonprice')
    },
    low_stock_page() {
      this.$router.push('/warehousereport/warehousequantity/1')
    },
    cn_page() {
      this.$router.push('/refund/refundwaitforprocess')
    },
    low_price_page() {
      this.$router.push('/stock/manage_product/productlowcost')
    },
    high_price_page() {
      this.$router.push('/stock/manage_product/producthighcost')
    },
    order_stable() {
      this.$router.push('/sell/orderretailcustomers')
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_line_second {
  display: grid;
  grid-template-columns: 40% 60%;
  grid-gap: 15px 0;
}
.grid_customer_list {
  display: grid;
  grid-template-columns: 15% 85%;
  grid-gap: 15px 0;
}
.grid_count {
  display: grid;
  grid-template-columns: 25% 75%;
}
.grid_product_three {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}
.grid_product_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.font_customer {
  font-size: 20px !important;
}
@media only screen and (max-width: 1180px) {
  .grid_line_second {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .font_customer {
    font-size: 18px !important;
  }
}
@media only screen and (max-width: 740px) {
  .font_customer {
    font-size: 16px !important;
  }
}
@media only screen and (max-width: 500px) {
  .grid_product_three {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_product_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_customer_list {
    display: grid;
    grid-template-columns: 25% 75%;
    grid-gap: 15px 0;
  }
}
</style>
